import SEO from "@/components/SEO";
import { Check, X, Minus } from "lucide-react";

const ROWS = [
  { label: "Pigment Yoğunluğu", wunberg: "Maksimum", competitor_a: "Orta", competitor_b: "Düşük", winner: "wunberg" },
  { label: "UV Solma Dayanımı (yıl)", wunberg: "10+", competitor_a: "5-7", competitor_b: "3-5", winner: "wunberg" },
  { label: "Kuruma Süresi", wunberg: "20-30 dk", competitor_a: "30-45 dk", competitor_b: "45-60 dk", winner: "wunberg" },
  { label: "Su Bazlı / Çevre Dostu", wunberg: true, competitor_a: true, competitor_b: false, winner: "wunberg" },
  { label: "Toksik Olmayan (AP Onaylı)", wunberg: true, competitor_a: false, competitor_b: false, winner: "wunberg" },
  { label: "Pürüzsüz Akış (Reoloji)", wunberg: "Premium", competitor_a: "İyi", competitor_b: "Orta", winner: "wunberg" },
  { label: "Renk Çeşitliliği", wunberg: "120+", competitor_a: "80", competitor_b: "60", winner: "wunberg" },
  { label: "Karışım Uyumluluğu", wunberg: "Tam", competitor_a: "Kısmen", competitor_b: "Sınırlı", winner: "wunberg" },
  { label: "Esnek Film Yapısı", wunberg: true, competitor_a: false, competitor_b: false, winner: "wunberg" },
  { label: "Fiyat / Performans", wunberg: "Çok İyi", competitor_a: "Orta", competitor_b: "Düşük", winner: "wunberg" },
];

function Cell({ value, isWinner }) {
  if (value === true)
    return <Check size={20} className={isWinner ? "text-[#d4af37]" : "text-[#2e7d32]"} />;
  if (value === false)
    return <X size={20} className="text-[#d32f2f]/70" />;
  return <span className={`text-sm ${isWinner ? "text-[#d4af37] font-semibold" : "text-[#a0aabf]"}`}>{value}</span>;
}

export default function Comparison() {
  return (
    <>
      <SEO
        title="Kalite Karşılaştırma — Wünberg vs Rakipler"
        description="Wünberg akrilik boyaların rakip markalara karşı pigment, UV dayanımı, çevre uyumu ve fiyat/performans karşılaştırması."
      />
      <section className="pt-32 pb-12 border-b border-white/10">
        <div className="wb-container">
          <div className="wb-overline">Karşılaştırma</div>
          <h1 className="wb-h1 mt-3">Rakamlar <span className="italic text-[#d4af37]">yalan</span> söylemez.</h1>
          <p className="wb-body mt-5 max-w-2xl">
            Wünberg akrilik boyaların, piyasanın önde gelen iki rakip markasına karşı
            bağımsız laboratuvar testlerinde elde ettiği sonuçlar.
          </p>
        </div>
      </section>

      <section className="wb-section">
        <div className="wb-container">
          <div className="wb-card overflow-x-auto">
            <table className="w-full min-w-[720px]">
              <thead>
                <tr className="border-b border-white/10">
                  <th className="text-left p-6 text-xs uppercase tracking-widest text-[#a0aabf]">Kriter</th>
                  <th className="p-6 text-center border-l border-white/10 bg-[#d4af37]/10">
                    <div className="font-serif text-xl text-[#d4af37]">Wünberg</div>
                    <div className="text-[10px] uppercase tracking-widest text-[#d4af37]/70 mt-1">Premium</div>
                  </th>
                  <th className="p-6 text-center border-l border-white/10">
                    <div className="font-serif text-lg">Rakip A</div>
                    <div className="text-[10px] uppercase tracking-widest text-[#a0aabf] mt-1">Standart</div>
                  </th>
                  <th className="p-6 text-center border-l border-white/10">
                    <div className="font-serif text-lg">Rakip B</div>
                    <div className="text-[10px] uppercase tracking-widest text-[#a0aabf] mt-1">Ekonomik</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {ROWS.map((r, i) => (
                  <tr key={i} className="border-b border-white/5" data-testid={`compare-row-${i}`}>
                    <td className="p-5 text-sm">{r.label}</td>
                    <td className="p-5 text-center border-l border-white/10 bg-[#d4af37]/5">
                      <div className="flex justify-center"><Cell value={r.wunberg} isWinner={r.winner === "wunberg"} /></div>
                    </td>
                    <td className="p-5 text-center border-l border-white/10">
                      <div className="flex justify-center"><Cell value={r.competitor_a} /></div>
                    </td>
                    <td className="p-5 text-center border-l border-white/10">
                      <div className="flex justify-center"><Cell value={r.competitor_b} /></div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="pb-32">
        <div className="wb-container grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { t: "Bağımsız Test", d: "Her parti TÜV Rheinland akredite laboratuvarında test edilir." },
            { t: "Sertifikalı Güvenlik", d: "EN 71-3, REACH ve AP onaylı; çocuk dahil tüm yaşlar için güvenli." },
            { t: "Şeffaf İletişim", d: "Tüm test sonuçlarımız talep üzerine bayi ve müşterilerle paylaşılır." },
          ].map((b) => (
            <div key={b.t} className="wb-card p-8">
              <Minus className="text-[#d4af37]" />
              <div className="font-serif text-xl mt-4">{b.t}</div>
              <p className="text-sm text-[#a0aabf] mt-2">{b.d}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
